
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './ProduktSklep.css';
import MenuTop from '../../components/MenuTop/MenuTop.js';

export default function ProduktSklep() {

    return (
        <Container fluid>
            <Row>
                <Col>
                    <MenuTop />
                </Col>
            </Row>
            <Row>
                <Col className="col-2">
                    <img alt="a" style={{ width: 150 + 'px' }} src="https://storage.mojegs1.pl/mojegs1/products/590/046/700/05900467000078_MARKT_S.jpg" />
                </Col>
                <Col className="col-xl-10">
                    <Container fluid >
                        <Row>
                            <Col>
                                <h4>Nazwa sklepu</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Produkt
                </Col>

                        </Row>
                        <Row>
                            <Col>
                                Producent
                </Col>
                        </Row>
                        <Row>
                            <Col>
                                Kod
                </Col>
                        </Row>
                        <Row>
                            <Col>
                                Opis
                </Col>
                        </Row>
                    </Container>
                </Col>

            </Row>


        </Container>
    );

}
